<template>
  <div
    class="app-horizontal-list"
    :class="{ 'negative-margin': negativeMargin }"
    :style="{ padding }"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'AppHorizontalList',

  props: {
    padding: {
      type: String,
      default: '28px',
    },

    negativeMargin: {
      type: Boolean,
      default: true,
    },
  },
}
</script>

<style lang="scss" scoped>
@use '@/styles/settings.scss' as *;

.app-horizontal-list {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  overflow-x: auto;
  align-items: center;

  &:after {
    content: '';
    padding-right: inherit;
    height: 1px;
  }

  > * {
    margin-left: 0.5rem;

    &:first-child {
      margin-left: 0;
    }
  }
}
</style>
